import { render, staticRenderFns } from "./SortGroupModal.vue?vue&type=template&id=54c5f971&scoped=true&"
import script from "./SortGroupModal.vue?vue&type=script&lang=js&"
export * from "./SortGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./SortGroupModal.vue?vue&type=style&index=0&id=54c5f971&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5f971",
  null
  
)

export default component.exports